"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var lodash_1 = require("lodash");
var use_places_autocomplete_1 = __importDefault(require("use-places-autocomplete"));
var searchParamsSlice_1 = require("../../features/searchParams/searchParamsSlice");
var globalSlice_1 = require("../../features/global/globalSlice");
var store_1 = require("../../app/store");
var SuggestionsList_1 = __importDefault(require("./SuggestionsList"));
var combobox_1 = require("@reach/combobox");
var SavedList_1 = __importDefault(require("./SavedList"));
var addressGeometries_1 = require("../../helpers/addressGeometries");
var SearchIcon_1 = __importDefault(require("./SearchIcon"));
var ClearSearchIcon_1 = __importDefault(require("./ClearSearchIcon"));
var usePrevious_1 = require("../../hooks/usePrevious");
var MissingDataSuggestions_1 = __importDefault(require("./MissingDataSuggestions"));
require("@reach/combobox/styles.css");
var classnames_1 = __importDefault(require("classnames"));
var PlacesAutocomplete = function (_a) {
    var onSelect = _a.onSelect, addressPickerSelection = _a.addressPickerSelection, placeholderText = _a.placeholderText, initialValue = _a.initialValue, onChangeHandler = _a.onChangeHandler, _b = _a.popoverClassName, popoverClassName = _b === void 0 ? 'map-search-popover' : _b, state = _a.state, district = _a.district, onClearAddress = _a.onClearAddress, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, catchWhenValueIsEmpty = _a.catchWhenValueIsEmpty, addressIsRemoved = _a.addressIsRemoved;
    var _d = use_places_autocomplete_1.default({
        requestOptions: {
            componentRestrictions: {
                country: ['am'],
            },
        },
        debounce: 300,
    }), ready = _d.ready, value = _d.value, data = _d.suggestions.data, setValue = _d.setValue, clearSuggestions = _d.clearSuggestions;
    var t = react_i18next_1.useTranslation('common').t;
    var placeholder = placeholderText
        ? placeholderText
        : t('PLACES_AUTOCOMPLETE.PLACEHOLDER');
    var dispatch = store_1.useAppThunkDispatch();
    var userLocation = react_redux_1.useSelector(globalSlice_1.useSelectUserLocation);
    var recentAddress = react_redux_1.useSelector(globalSlice_1.useSelectRecentAddressSearch);
    var _e = react_1.useState(false), customBoxVisible = _e[0], setCustomBoxVisible = _e[1];
    var _f = react_1.useState([]), recentList = _f[0], setRecentList = _f[1];
    var _g = react_1.useState([]), suggestions = _g[0], setSuggestions = _g[1];
    var _h = react_1.useState(false), isTyping = _h[0], setIsTyping = _h[1];
    var _j = react_1.useState(), missingData = _j[0], setMissingData = _j[1];
    var previousValue = usePrevious_1.usePrevious(value);
    var previousInitialValue = usePrevious_1.usePrevious(initialValue);
    react_1.useEffect(function () {
        dispatch(globalSlice_1.getUserLocation());
    }, []);
    react_1.useEffect(function () {
        setSuggestions(data);
    }, [data]);
    react_1.useEffect(function () {
        var delayDebounceFn;
        if (isTyping && value && !data.length) {
            delayDebounceFn = setTimeout(function () {
                fetchGetMissingData();
            }, 1500);
        }
        if (data.length) {
            setMissingData([]);
        }
        return function () { return clearTimeout(delayDebounceFn); };
    }, [isTyping, value, data]);
    react_1.useEffect(function () {
        if (recentAddress && userLocation) {
            var addressed = recentAddress.map(function (address) { return ({
                data: address,
                type: 'recent',
            }); });
            setRecentList(__spreadArray([
                {
                    type: 'my_location',
                    data: userLocation,
                }
            ], addressed));
        }
    }, [recentAddress, userLocation]);
    react_1.useEffect(function () {
        if (initialValue && !lodash_1.isUndefined(previousInitialValue)) {
            setValue(initialValue, false);
            addCustomPlaceInFirstLoad();
        }
    }, [initialValue, previousInitialValue]);
    react_1.useEffect(function () {
        ((state === null || state === void 0 ? void 0 : state.length) || (district === null || district === void 0 ? void 0 : district.length)) && setValue('');
    }, [state, district]);
    react_1.useEffect(function () {
        if (!value.length &&
            !lodash_1.isUndefined(previousValue) &&
            previousValue.length) {
            !lodash_1.isUndefined(catchWhenValueIsEmpty) && catchWhenValueIsEmpty();
        }
    }, [value]);
    react_1.useEffect(function () {
        !lodash_1.isUndefined(addressIsRemoved) && addressIsRemoved && clearSearch();
    }, [addressIsRemoved]);
    var fetchGetMissingData = function () {
        if (value.length) {
            dispatch(searchParamsSlice_1.getMissingData(value)).then(function (data) {
                data && setMissingData(data);
            });
        }
    };
    var handleSelect = function (address) {
        setIsTyping(false);
        if ((missingData === null || missingData === void 0 ? void 0 : missingData.length) && !data.length) {
            handleSelectByMissingData(address);
        }
        else {
            handleSelectByGoogle(address);
        }
    };
    var handleSelectByMissingData = function (address) {
        var filteredData = missingData === null || missingData === void 0 ? void 0 : missingData.find(function (item) { return item.display_name === address; });
        if (filteredData) {
            setMissingData([]);
            dispatch(searchParamsSlice_1.getMissingDataDetails(filteredData.osm_type.charAt(0).toUpperCase(), String(filteredData.osm_id), filteredData.category)).then(function (placeDetails) {
                if (placeDetails) {
                    var data_1 = addressGeometries_1.combineMissingDataToOnSelect(filteredData, placeDetails);
                    dispatch(searchParamsSlice_1.removeSelectedAllDistricts());
                    makeOnChangeHandler(data_1.main_text);
                    clearSuggestions();
                    makeAddressPickerSelectionChange(data_1);
                    lodash_1.isFunction(onSelect) && onSelect(data_1);
                }
            });
        }
    };
    var handleSelectByGoogle = function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var prediction, addressGeocode, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    prediction = data.find(function (prediction) { return prediction.description === address; });
                    if (prediction) {
                        setValue(prediction.structured_formatting.main_text, false);
                        makeOnChangeHandler(prediction.structured_formatting.main_text);
                        clearSuggestions();
                    }
                    dispatch(searchParamsSlice_1.removeSelectedAllDistricts());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, addressGeometries_1.getAddressGeocode(address, prediction)];
                case 2:
                    addressGeocode = _a.sent();
                    if (!lodash_1.isUndefined(addressGeocode)) {
                        makeAddressPickerSelectionChange(addressGeocode.selectedPlace);
                        lodash_1.isFunction(onSelect) && onSelect(addressGeocode.selectedPlace);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.log('Something went wrong!', e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var makeAddressPickerSelectionChange = function (selectedPlace) {
        if (!lodash_1.isFunction(addressPickerSelection)) {
            dispatch(searchParamsSlice_1.setCustomPlace(selectedPlace));
            dispatch(globalSlice_1.addToRecentAddressSearch(selectedPlace));
        }
        if (lodash_1.isFunction(addressPickerSelection)) {
            addressPickerSelection(selectedPlace);
        }
    };
    var makeOnChangeHandler = function (value) {
        lodash_1.isFunction(onChangeHandler) && onChangeHandler(value);
    };
    var clearSearch = function () {
        setValue('', true);
        lodash_1.isFunction(onChangeHandler) && onChangeHandler('');
        lodash_1.isFunction(onClearAddress) && onClearAddress();
        setMissingData([]);
    };
    var handleRecentSelection = function (address) {
        if (!address.data) {
            dispatch(globalSlice_1.addToastMessage({
                text: "Can't access location",
                appearance: 'info',
            }));
        }
        if (address.type != 'my_location' && address.data) {
            dispatch(globalSlice_1.addToRecentAddressSearch(address.data));
        }
        if (lodash_1.isFunction(addressPickerSelection)) {
            addressPickerSelection(address.data);
        }
        else {
            dispatch(searchParamsSlice_1.setCustomPlace(address.data));
        }
        address.data && setValue(address.data.main_text, false);
        lodash_1.isFunction(onSelect) && onSelect(address.data);
        dispatch(searchParamsSlice_1.removeSelectedAllDistricts());
    };
    var toggleCustomBox = function () {
        setCustomBoxVisible(!customBoxVisible);
    };
    var handleKeyPressCapture = function () {
        var filteredPlace = recentList.find(function (item) { var _a; return ((_a = item.data) === null || _a === void 0 ? void 0 : _a.main_text) === initialValue; });
        (filteredPlace === null || filteredPlace === void 0 ? void 0 : filteredPlace.data) &&
            lodash_1.isFunction(onSelect) &&
            onSelect(filteredPlace.data);
    };
    var addCustomPlaceInFirstLoad = function () { return __awaiter(void 0, void 0, void 0, function () {
        var prediction, addressGeocode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    prediction = data.find(function (prediction) { return prediction.description === initialValue; });
                    if (!prediction) return [3 /*break*/, 2];
                    return [4 /*yield*/, addressGeometries_1.getAddressGeocode(initialValue, prediction)];
                case 1:
                    addressGeocode = _a.sent();
                    if (!lodash_1.isUndefined(addressGeocode)) {
                        dispatch(searchParamsSlice_1.setCustomPlace(addressGeocode.selectedPlace));
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleInputChange = function (value) {
        setValue(value);
        setIsTyping(true);
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('place-autocomplete-box', {
            'autocomplete-focused': customBoxVisible,
        }) },
        react_1.default.createElement("div", { className: "inner" },
            react_1.default.createElement(SearchIcon_1.default, { value: value }),
            react_1.default.createElement(combobox_1.Combobox, { "aria-label": "Places", className: "map-search-box", onSelect: handleSelect, openOnFocus: true },
                react_1.default.createElement(combobox_1.ComboboxInput, { onFocus: toggleCustomBox, onBlur: toggleCustomBox, placeholder: placeholder, onChange: function (e) {
                        return !isDisabled && handleInputChange(e.target.value);
                    }, onKeyPressCapture: handleKeyPressCapture, disabled: !ready, value: value }),
                !!suggestions.length && (react_1.default.createElement(SuggestionsList_1.default, { data: suggestions, value: value, popoverClassName: popoverClassName })),
                !!(missingData === null || missingData === void 0 ? void 0 : missingData.length) && !suggestions.length && (react_1.default.createElement(MissingDataSuggestions_1.default, { data: missingData, popoverClassName: popoverClassName }))),
            react_1.default.createElement(ClearSearchIcon_1.default, { clearSearch: clearSearch, isDisabled: isDisabled, isClose: !!value })),
        !isDisabled && (react_1.default.createElement(SavedList_1.default, { recentList: recentList, handleRecentSelection: handleRecentSelection, customBoxVisible: customBoxVisible, isHidden: !!value }))));
};
exports.default = react_1.default.memo(PlacesAutocomplete);
